import { all, call, put, takeLatest, takeLeading, } from 'redux-saga/effects';

import { pick } from 'helpers/tools'

import * as apicore from "services/core";
import * as type from './constant';
import * as action from './action';


function* getItem({ agencyId, selfRole }) {
  try {

    const response = yield call(apicore.getAgencyConfigRequest, agencyId, selfRole);
    yield put(action.getAgencyConfigSuccess(response, agencyId));

  } catch (error) {
    yield put(action.getAgencyConfigError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* updateItem({ agencyId, payload, selfRole }) {
  try {
    
    const formattedPayload = {};

    const agencyKeys = ['name', 'short_name', 'address'];
    if (Object.keys(payload).some(x => agencyKeys.includes(x))) {
      formattedPayload.agency = {
        ...pick(payload, agencyKeys)
      }
    }

    const configKeys = Object.keys(payload).filter(x => !agencyKeys.includes(x))
    if (Object.keys(payload).some(x => configKeys.includes(x))) {
      const mainConfigKeys = ['agency_head', 'member_manager', 'allowance_manager'];
      const configTaskKeys = ['letter_number_counter', 'letter_agency_identifier', 'asignee_limit_per_letter_number', 'limit_per_month', 'allow_limit_per_month_tolerance', 'origin', 'additional_assignors_position', 'assignor_agency_of_agency_head'];
      formattedPayload.config = {
        ...pick(payload, mainConfigKeys)
      }

      if (Object.keys(payload).some(x => configTaskKeys.includes(x))) {
        formattedPayload.config.task = {
          ...pick(payload, configTaskKeys)
        }
      }
    }

    const { config } = yield call(apicore.updateAgencyConfigRequest, agencyId, formattedPayload, selfRole);
    yield put(action.updateAgencyConfigSuccess(config, agencyId));

  } catch (error) {
    yield put(action.manipulationAgencyConfigError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* deleteItem({ agencyId, selfRole }) {
  try {

    yield call(apicore.deleteAgencyConfigRequest, agencyId, selfRole);
    yield put(action.deleteAgencyConfigSuccess(true));

  } catch (error) {
    yield put(action.manipulationAgencyConfigError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

export function* watchGetList() {
  yield takeLatest(type.GET, getItem);
}
export function* watchUpdateItem() {
  yield takeLeading(type.UPDATE, updateItem);
}
export function* watchDeleteItem() {
  yield takeLeading(type.DELETE, deleteItem);
}

export default function* rootSaga() {
  yield all([
    watchGetList(),
    watchUpdateItem(),
    watchDeleteItem(),
  ]);
}
